import { render, staticRenderFns } from "./PricingMobileAnnual.vue?vue&type=template&id=64e26cb3&scoped=true&"
import script from "./PricingMobileAnnual.vue?vue&type=script&lang=js&"
export * from "./PricingMobileAnnual.vue?vue&type=script&lang=js&"
import style0 from "./PricingMobileAnnual.vue?vue&type=style&index=0&id=64e26cb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e26cb3",
  null
  
)

export default component.exports